import React, { useContext } from "react";

// ************************************

// En attente de connaître nos besoins
// Besoin de choisir si on conserve la lib Flynt ou la lib du DS

// notistack Flynt
// DS react-toastify

// ************************************

/**
 * Toast context
 */
export const ToastContext = React.createContext({});

/**
 * Hook to access toast context
 */
export function useToast() {
    return useContext(ToastContext);
}
